import { APP_BUILD_NUMBER } from '../config/appInfo';

const PATH_TO_PAGE_ID = {
  '/': 'home',
  '/residents': 'residents',
  '/locks': 'locks',
  '/assignments': 'assignments',
  '/orders': 'orders',
  '/phones': 'phones',
  '/access-groups': 'access-groups',
  '/reports': 'reports',
  '/logs': 'reports',
  '/hjelp': 'help',
  '/ingen-tilgang': 'access-denied',
  '/login': 'login'
};

export const HELP_PDF = {
  nb: `${process.env.PUBLIC_URL || ''}/docs/OpenCare-Bruksanvisning-nb.pdf`,
  en: `${process.env.PUBLIC_URL || ''}/docs/OpenCare-User-Guide-en.pdf`
};

export const HELP_PAGE_LABELS = {
  home: { nb: 'Hjem', en: 'Home' },
  residents: { nb: 'Innbyggere', en: 'Residents' },
  locks: { nb: 'Låser', en: 'Locks' },
  assignments: { nb: 'Tilordninger', en: 'Assignments' },
  orders: { nb: 'Bestillinger', en: 'Orders' },
  phones: { nb: 'Telefoner', en: 'Phones' },
  'access-groups': { nb: 'Tilgangsgrupper', en: 'Access groups' },
  reports: { nb: 'Rapporter', en: 'Reports' },
  help: { nb: 'Hjelp', en: 'Help' },
  'access-denied': { nb: 'Ingen tilgang', en: 'No access' },
  login: { nb: 'Innlogging', en: 'Sign-in' },
  unknown: { nb: 'Ukjent side', en: 'Unknown page' }
};

/**
 * Stable page id for help/AI context (not the raw path).
 */
export function getHelpPageId(pathname = '/') {
  const path = String(pathname || '/').split('?')[0] || '/';
  if (PATH_TO_PAGE_ID[path]) {
    return PATH_TO_PAGE_ID[path];
  }
  const segment = path.replace(/^\//, '').split('/')[0];
  return segment || 'unknown';
}

export function getHelpPageLabel(pageId, lang = 'nb') {
  const labels = HELP_PAGE_LABELS[pageId] || HELP_PAGE_LABELS.unknown;
  return lang === 'en' ? labels.en : labels.nb;
}

/**
 * In-app help URL with language, build version, and page id.
 */
export function buildHelpUrl({ lang = 'nb', pathname = '/' } = {}) {
  const params = new URLSearchParams({
    lang: lang === 'en' ? 'en' : 'nb',
    v: APP_BUILD_NUMBER || 'local',
    page: getHelpPageId(pathname)
  });
  return `/hjelp?${params.toString()}`;
}

export function getManualPdfUrl(lang = 'nb') {
  return lang === 'en' ? HELP_PDF.en : HELP_PDF.nb;
}
